angular.module("EventsApp").run(["$rootScope",
    function ($rootScope) {
        $rootScope.in_app_links_template = '/static/assets/khapps/events/partials/events_navbar_links.html';
        $rootScope.select_filters_template = "/static/assets/khapps/events/partials/events_navbar_filters.html";
    }]);